export const ROOM_SUCCESS = "ROOM_SUCCESS";
export const ROOM = "ROOM";
export const ROOM_BY_PROJECT_ID = "ROOM_BY_PROJECT_ID";
export const ROOM_BY_ID = "ROOM_BY_ID";
export const ROOM_ID = "ROOM_ID";
export const ROOM_DELETED = "ROOM_DELETED";
export const ROOM_ERROR = "ROOM_ERROR";
